export const VALIDATE_FORM = "VALIDATE_FORM";

export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";

export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const SUCCESS_REGISTRATION = "SUCCESS_REGISTRATION";
export const ERROR_REGISTRATION = "ERROR_REGISTRATION";
export const AUTHENTICATED_USER = "AUTHENTICATED_USER";
export const SUCCESS_LOGIN = "SUCCESS_LOGIN";
export const ERROR_LOGIN = "ERROR_LOGIN";
export const CLOSE_SESION = "CLOSE_SESION";
export const SUCCESS_FORGOT_PASSWORD = "SUCCESS_FORGOT_PASSWORD";
export const ERROR_FORGOT_PASSWORD = "ERROR_FORGOT_PASSWORD";

export const SUCCESS_GET_DATA_TRANSACTIONS = "SUCCESS_GET_DATA_TRANSACTIONS";
export const SUCCESS_GET_DATA_SHIFTCLOSURES = "SUCCESS_GET_DATA_SHIFTCLOSURES";
export const SUCCESS_GET_DATA_RCOFHISTORY = "SUCCESS_GET_DATA_RCOFHISTORY";
export const CHANGE_PAGE = "CHANGE_PAGE";
export const CHANGE_LOADING = "CHANGE_LOADING";
export const ERROR_GET_DATA = "ERROR_GET_DATA";
export const SET_FILTER = "SET_FILTER";
export const WITH_FILTERS = "WITH_FILTERS";
export const REMOVE_FILTERS = "REMOVE_FILTERS";
export const SET_QUERY_FILE = "SET_QUERY_FILE";

export const SET_MAX_PER_PAGE = "SET_MAX_PER_PAGE";

export const SET_TRANSACTION_TABLE = "SET_TRANSACTION_TABLE";
export const SET_SHIFT_CLOSURES_TABLE = "SET_SHIFT_CLOSURES_TABLE";
export const SET_RCOF_HISTORY_TABLE = "SET_RCOF_HISTORY_TABLE";

export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";

export const CHANGE_PASSWORD_OK = "CHANGE_PASSWORD_OK";
export const TELL_A_FRIEND_OK = "TELL_A_FRIEND_OK";
export const REGENERATE_UNAUTHORIZED_DOCUMENTS = "REGENERATE_UNAUTHORIZED_DOCUMENTS";
export const GET_PENDING_DOCUMENTS = "GET_PENDING_DOCUMENTS";
export const ASK_FOR_ANEW_SERVICE_OK = "ASK_FOR_ANEW_SERVICE_OK";
export const RECEIVE_NEW_VOUCHER_TO_PROCESS_OK = "RECEIVE_NEW_VOUCHER_TO_PROCESS_OK";

export const SET_AUTH = "SET_AUTH"

export const GET_THE_NEWS_RESPONSE = "GET_THE_NEWS_RESPONSE"
export const GET_DASHBOARDBILL_RESPONSE='GET_DASHBOARDBILL_RESPONSE'
export const GET_DASHBOARDBILL_DATA = 'GET_DASHBOARDBILL_DATA'
export const PORTAL_SET_IS_BILL ='PORTAL_SET_IS_BILL'

export const SET_MODAL_TITLE = 'SET_MODAL_TITLE'
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT'
